import { when, juxt, xprod, __, pipe, pipeWith, pluck, fromPairs, filter, map, length, andThen, find, propOr, propEq } from 'ramda'

function create (app, config) {
  const tags = [
    'order ahead',
    'pre-order food',
    'grab ordering',
    'mobile food ordering',
    'contactless order/pay'
  ]

  const sendDynamicPoiData = pipe(
    xprod(__, [{ enabled: true, tags }]), // create pair [poiId, dynamicAttributes]
    fromPairs, // create object (map) from pairs
    idValuesMap => app.bus.send('poi/setDynamicData', { plugin: 'grab', idValuesMap })
  )

  const notifyMapGrabPois = ids =>
    app.bus.send('map/addCustomBadges', { ids, badge: 'pin.grabordering' })

  const notifyGrabPois = pipeWith(andThen)([
    () => app.bus.get('venueData/getGrabPoiIds'), // fetch grab ids
    map(id => app.bus.get('poi/getById', { id })),
    promises => Promise.all(promises),
    filter(pipe(propOr([], 'links'), find(propEq('grab', 'type')))),
    pluck('poiId'),
    when(length, juxt([sendDynamicPoiData, notifyMapGrabPois])) // if there are grab ids in venue data, then call each function with them
  ])

  const isVenueGrabEnabled = () => app.bus.get('venueData/isGrabEnabled')

  const init = () => {
    isVenueGrabEnabled().then(isEnabled => {
      if (isEnabled) {
        app.bus.send('search/addKeywords', { keywords: tags })
        notifyGrabPois()
      } else {
        app.bus.send('homeView/hideCategory', { category: 'grab' })
      }
    })
  }

  return {
    init
  }
}

export {
  create
}
